import { render } from "./OverlayDialog.vue?vue&type=template&id=4e8b3869&scoped=true"
import script from "./OverlayDialog.vue?vue&type=script&lang=js"
export * from "./OverlayDialog.vue?vue&type=script&lang=js"

import "./OverlayDialog.vue?vue&type=style&index=0&id=4e8b3869&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8b3869"]])

export default __exports__